<ng-template #templatePagination let-pagination>
  <div class="ag-paging-panel ag-unselectable">
    <span class="ag-paging-row-summary-panel" aria-hidden="true">
      {{ pagination.labels.startRow }}-{{ pagination.labels.endRow }}&nbsp;{{ 'tables_of' | translate }}&nbsp;{{
        pagination.labels.rowCount
      }}
      <!--       &nbsp;{{ 'tables_results' | translate }}-->
    </span>
    <ng-select
      (change)="pagination.functions.onPageSizeChange($event)"
      [items]="pagination.labels.paginationPerPageOptions"
      bindLabel="label"
      bindValue="value"
      [ngModel]="pagination.labels.pageSize"
      [clearable]="false"
      class="form-control"
    >
    </ng-select>
    <!--    <span>{{ 'tables_perpage' | translate }}</span>-->
    <div class="pagination-pageselector">
      <span
        [ngClass]="{ 'paging-disabled': !pagination.labels.hasPrevious }"
        class="paging-page paging-page-prevnext"
        (click)="pagination.functions.goToPreviousPage()"
        >&lt;
      </span>
      <ng-container *ngFor="let page of pagination.labels.pages">
        <span *ngIf="page === '...'">&hellip;</span>
        <span
          (click)="pagination.functions.goToPage(page)"
          class="paging-page"
          *ngIf="page !== '...'"
          [ngClass]="{ 'paging-current': pagination.labels.currentPage === page }"
          >{{ page }}</span
        >
      </ng-container>
      <span
        [ngClass]="{ 'paging-disabled': !pagination.labels.hasNext }"
        class="paging-page paging-page-prevnext"
        (click)="pagination.functions.goToNextPage()"
      >
        &gt;</span
      >
    </div>
    <div class="pagination-pageinput">
      <span>{{ 'tables_gotopage' | translate }}</span>
      <form (submit)="pagination.functions.goToPage(pagination.labels.goToPage)" action="#">
        <div class="input-group">
          <input
            [min]="1"
            [max]="pagination.labels.totalPages"
            [(ngModel)]="pagination.labels.goToPage"
            [ngModelOptions]="{ standalone: true }"
            type="number"
            class="form-control"
          />
          <div class="input-group-append">
            <input
              [disabled]="pagination.labels.goToPage < 1 || pagination.labels.goToPage > pagination.labels.totalPages"
              type="submit"
              value="{{ 'tables_pagego' | translate }}"
            />
          </div>
        </div>
      </form>
    </div>
  </div>
</ng-template>
<div class="col-12 costum-grid" *ngIf="options.enableSelect || options.bulkOptions || options.filters || !options.disablePagination">
  <!--<div style="background:red" class="atlas-grid-topfilters atlas-grid-topfilters-def row" [ngClass]="{ 'atlas-grid-topfilters-has-filters': options.bulkOptions, 'atlas-grid-topfilters-enabled': !loading && numSelected==0 }"  *ngIf="columnDefs && options && localeReady">-->

  <!--</div>-->
  <div
    class="atlas-grid-topfilters row"
    [ngClass]="{
      'atlas-grid-topfilters-selecting': !loading && numSelected > 0 && page !== 'contacts',
      'atlas-grid-topfilters-has-filters': options.enableSelect || options.bulkOptions
    }"
    *ngIf="columnDefs && options && localeReady"
  >
    <div class="atlas-grid-topfilters-bar col-12 col-lg-4 d-flex">
      <a *ngIf="options.filters" (click)="filtersClick($event)" href="#" id="atlas-gridfilter">
        <wsb-atlas-button
          [inlineIcon]="'assets/images/icons/icon-filter.svg'"
          id="atlas-gridfilter-btn"
          class="mb-2"
          [ngClass]="{ open: showFilters, 'filters-applied': filtersApplied }"
          [variant]="'primary'"
          [label]="'tables_filter'"
        ></wsb-atlas-button>
        <span class="filterappliedicon" *ngIf="filtersApplied" [inlineSVG]="'/assets/images/icons/grid/icon-active-filter.svg'"></span>
      </a>

      <a *ngIf="options.filtersAdvanced" (click)="filtersAdvancedClick($event)" href="#" id="atlas-gridfilteradvanced">
        <wsb-atlas-button
          [inlineIcon]="'assets/images/icons/icon-filters-advanced.svg'"
          id="atlas-gridfilteradvanced-btn"
          class="mb-2"
          [ngClass]="{ open: showFiltersAdvanced, 'filters-applied': filtersAdvancedApplied }"
          [variant]="'primary'"
          [label]="'tables_filter_advanced'"
        ></wsb-atlas-button>
        <span
          class="filteradvancedappliedicon"
          *ngIf="filtersAdvancedApplied"
          [inlineSVG]="'/assets/images/icons/grid/icon-active-filter.svg'"
        ></span>
      </a>

      <div
        class="dropdown dropdown-buttongroup dropdown-menu dropdown-gridcustomizecolumns"
        id="atlas-gridfilter-m"
        [attr.aria-labelledby]="'atlas-gridgroup'"
      >
        <p class="grid-drop-title" translate>tables_customize_columns_title</p>
        <p translate>tables_customize_columns_text</p>

        <div cdkDropList (cdkDropListDropped)="drop($event)">
          <div *ngFor="let column of columnPreferences" cdkDrag>
            <div
              style="margin-left: -7px;"
              [ngClass]="{ 'ag-checked': selectAll }"
              class="ag-wrapper ag-input-wrapper ag-checkbox-input-wrapper"
              role="presentation"
            >
              <span class="list-drag" [inlineSVG]="'assets/images/icons/icon-drag.svg'"></span>
              <input
                style="width:20px;flex:none;margin:0 10px;display:inline-block;"
                class="ag-input-field-input ag-checkbox-input"
                type="checkbox"
                [ngModel]="!column.hide"
                (ngModelChange)="column.hide = !$event"
              />
              <span *ngIf="column.labelTranslate">{{ column.label | translate }}</span>
              <span *ngIf="!column.labelTranslate">{{ column.label }}</span>
            </div>
          </div>
        </div>
        <wsb-atlas-button class="mb-2" [label]="'common_save'" [variant]="'primary'" (click)="saveColumnPreferences()"> </wsb-atlas-button>
      </div>

      <a
        *ngIf="columnPreferences"
        (click)="dropdownClick()"
        href="#"
        id="atlas-gridgroup"
        role="button"
        data-display="static"
        data-bs-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <wsb-atlas-button
          [inlineIcon]="'assets/images/icons/icon-customize.svg'"
          id="atlas-gridgroup-btn"
          class="mb-2"
          [variant]="'primary'"
          [label]="'tables_customize'"
        ></wsb-atlas-button>
      </a>
      <div
        class="dropdown dropdown-buttongroup dropdown-menu dropdown-gridcustomizecolumns"
        id="atlas-gridgroup-m"
        [attr.aria-labelledby]="'atlas-gridgroup'"
      >
        <p class="grid-drop-title" translate>tables_customize_columns_title</p>
        <p translate>tables_customize_columns_text</p>

        <div cdkDropList (cdkDropListDropped)="drop($event)">
          <div *ngFor="let column of columnPreferences" cdkDrag>
            <div
              style="margin-left: -7px;"
              [ngClass]="{ 'ag-checked': selectAll }"
              class="ag-wrapper ag-input-wrapper ag-checkbox-input-wrapper"
              role="presentation"
            >
              <span class="list-drag" [inlineSVG]="'assets/images/icons/icon-drag.svg'"></span>
              <input
                style="width:20px;flex:none;margin:0 10px;display:inline-block;"
                class="ag-input-field-input ag-checkbox-input column-checkbox"
                type="checkbox"
                [ngModel]="!column.hide"
                (ngModelChange)="column.hide = !$event"
              />
              <span *ngIf="column.labelTranslate">{{ column.label | translate }}</span>
              <span *ngIf="!column.labelTranslate">{{ column.label }}</span>
            </div>
          </div>
        </div>
        <wsb-atlas-button class="mb-2" [label]="'common_save'" [variant]="'primary'" (click)="saveColumnPreferences()"> </wsb-atlas-button>
      </div>

      <div class="atlas-grid-topfilters-bar col-12 col-lg-4 export">
        <a
          *ngIf="export"
          (click)="dropdownClick()"
          href="#"
          id="atlas-gridgroup"
          role="button"
          data-display="static"
          data-bs-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <wsb-atlas-button
            [inlineIcon]="'assets/images/icons/icon-export.svg'"
            id="atlas-gridgroup-btn"
            class="mb-2"
            [variant]="'primary'"
            [label]="'groups_table_action_export'"
          ></wsb-atlas-button>
        </a>
        <div
          class="dropdown dropdown-buttongroup dropdown-menu dropdown-gridcustomizecolumns"
          id="atlas-gridgroup-m"
          [attr.aria-labelledby]="'atlas-gridgroup'"
        >
          <p class="grid-drop-title" translate>groups_table_action_export</p>
          <p translate>{{ exportText }}</p>
          <p translate>common_export_text</p>
          <div wsbAppClickStopPropagation *ngIf="export" class="mb-2">
            <div class="d-flex align-items-center mb-2">
              <div class="w-100">
                <label class="radio-custom">
                  <input type="radio" [formControl]="exportFc" [value]="'XLS'" />
                  <span class="radio-custom__radio"></span>
                  <span class="radio-custom__label" translate>export_filetype_xls</span>
                </label>

                <label class="radio-custom">
                  <input type="radio" [formControl]="exportFc" [value]="'XLSX'" />
                  <span class="radio-custom__radio"></span>
                  <span class="radio-custom__label" translate>export_filetype_xlsx</span>
                </label>

                <label class="radio-custom">
                  <input type="radio" [formControl]="exportFc" [value]="'CSV'" />
                  <span class="radio-custom__radio"></span>
                  <span class="radio-custom__label" translate>export_filetype_csv</span>
                </label>
              </div>
            </div>
            <span translate>text_receive_email_account</span>
          </div>

          <div class="d-flex" style="justify-content: flex-end;">
            <div *ngFor="let button of exportButtons" class="my-2 d-flex" style="margin-right: 15px;">
              <wsb-atlas-button
                class="primary"
                variant="primary"
                [disabled]="!exportFc?.value"
                (btnClick)="exportClick(button.value)"
                [label]="button.label"
              ></wsb-atlas-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 col-lg-8 atlas-grid-pagination-top-container">
      <ng-template
        *ngIf="pagination && !options.disablePagination"
        [ngTemplateOutlet]="templatePagination"
        [ngTemplateOutletContext]="{ $implicit: pagination }"
      ></ng-template>
    </div>
  </div>

  <div *ngIf="showFilters" class="atlas-grid-topfilters-openbar row atlas-grid-topfilters-openbar-filters clearfix">
    <div class="col-12">
      <div [class]="'filteroption-type-' + filter.type" *ngFor="let filter of options.filters">
        <ng-container [ngSwitch]="filter.type">
          <label>
            <span>{{ filter.label | translate }}</span>
            <ng-container *ngSwitchCase="'dropdown'">
              <ng-select
                [(ngModel)]="filtersModel[filter.name]"
                (change)="onFilterChange($event)"
                [items]="filter.options"
                bindLabel="label"
                [clearable]="false"
                class="form-control bulk-options-changer"
              >
                <ng-template ng-label-tmp let-item="item" let-clear="clear">
                  <span *ngIf="!item.translate" class="ng-value-label">{{ item.label }}</span>
                  <span *ngIf="item.translate" class="ng-value-label">{{ item.label | translate }}</span>
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-search="searchTerm" let-index="index">
                  <span *ngIf="!item.translate">{{ item.label }}</span>
                  <span *ngIf="item.translate">{{ item.label | translate }}</span>
                </ng-template>
              </ng-select>
            </ng-container>
            <ng-container *ngSwitchCase="'phone'">
              <div class="filter-phone">
                <ng-select
                  [(ngModel)]="filtersModel[filter.name]"
                  (change)="onFilterChange($event)"
                  [items]="filter.options"
                  bindLabel="label"
                  [clearable]="false"
                  class="form-control bulk-options-changer"
                >
                  <ng-template ng-label-tmp let-item="item" let-clear="clear">
                    <span *ngIf="!item.translate" class="ng-value-label">{{ item.label }}</span>
                    <span *ngIf="item.translate" class="ng-value-label">{{ item.label | translate }}</span>
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item" let-search="searchTerm" let-index="index">
                    <span *ngIf="!item.translate">{{ item.label }}</span>
                    <span *ngIf="item.translate">{{ item.label | translate }}</span>
                  </ng-template>
                </ng-select>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'text'">
              <input class="form-control" [(ngModel)]="filtersModel[filter.name]" (change)="onFilterChange($event)" type="text" />
            </ng-container>
            <ng-container *ngSwitchCase="'date'">
              <wsb-atlas-datepicker
                (change)="onFilterChange($event)"
                [(ngModel)]="filtersModel[filter.name]"
                [min]="filter.min"
                [max]="filter.max"
              ></wsb-atlas-datepicker>
            </ng-container>
            <ng-container *ngSwitchCase="'dateMonthAndYear'">
              <wsb-atlas-datepicker-month
                (change)="onFilterChange($event)"
                [(ngModel)]="filtersModel[filter.name]"
                format="date"
                [min]="filter.min"
                [max]="filter.max"
              ></wsb-atlas-datepicker-month>
            </ng-container>
            <ng-container *ngSwitchCase="'dateShowOnlyYears'">
              <wsb-atlas-datepicker-only-years
                (change)="onFilterChange($event)"
                [(ngModel)]="filtersModel[filter.name]"
                format="date"
                [min]="filter.min"
                [max]="filter.max"
              ></wsb-atlas-datepicker-only-years>
            </ng-container>
            <ng-container *ngSwitchCase="'time'">
              <input
                class="form-control filter-time"
                (change)="onFilterChange($event)"
                type="time"
                showMaskTyped="true"
                [(ngModel)]="filtersModel[filter.name]"
              />
            </ng-container>
            <ng-container *ngSwitchCase="'dateShowOnlyMonths'">
              <wsb-atlas-datepicker-only-months
                (change)="onFilterChange($event)"
                [(ngModel)]="filtersModel[filter.name]"
                format="date"
                [min]="filter.min"
                [max]="filter.max"
              ></wsb-atlas-datepicker-only-months>
            </ng-container>
          </label>
        </ng-container>
      </div>
      <div class="filter-submit">
        <wsb-atlas-button class="mb-2" [label]="'common_search'" [variant]="'primary'" (click)="filter()"> </wsb-atlas-button>
      </div>
      <div class="filter-clear">
        <wsb-atlas-button class="mb-2" [label]="'common_reset'" [variant]="'link'" (click)="clearFilters()"> </wsb-atlas-button>
      </div>
    </div>
  </div>
  <div
    *ngIf="showFiltersAdvanced"
    class="atlas-grid-topfilters-openbar row atlas-grid-topfilters-openbar-filters atlas-grid-topfilters-openbar-filters-advanced clearfix"
  >
    <div class="col-12">
      <div class="row" *ngFor="let filterRow of filtersAdvancedModel; let i = index; let last = last">
        <div class="col-3">
          <ng-select
            placeholder="{{ 'tables_filter' | translate }}"
            [(ngModel)]="filterRow.filter"
            (change)="onFilterAdvancedChange($event, filterRow)"
            [items]="options.filtersAdvanced"
            bindLabel="label"
            [clearable]="false"
            class="form-control bulk-options-changer"
          >
            <ng-template ng-label-tmp let-item="item" let-clear="clear">
              <span *ngIf="!item.translate" class="ng-value-label">{{ item.label }}</span>
              <span *ngIf="item.translate" class="ng-value-label">{{ item.label | translate }}</span>
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-search="searchTerm" let-index="index">
              <span *ngIf="!item.translate">{{ item.label }}</span>
              <span *ngIf="item.translate">{{ item.label | translate }}</span>
            </ng-template>
          </ng-select>
        </div>
        <div class="col-3">
          <ng-select
            [(ngModel)]="filterRow.operation"
            [disabled]="!filterRow.filter"
            [items]="
              filterRow.filter
                ? filterRow.filter.operations
                  ? filterRow.filter.operations
                  : filtersAdvancedDefaultOperations[filterRow.filter.type]
                : []
            "
            bindLabel="label"
            [clearable]="false"
            class="form-control bulk-options-changer"
          >
            <ng-template ng-label-tmp let-item="item" let-clear="clear">
              <span class="ng-value-label">{{ item.label | translate }}</span>
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-search="searchTerm" let-index="index">
              <span>{{ item.label | translate }}</span>
            </ng-template>
          </ng-select>
        </div>
        <div class="col-3">
          <ng-container *ngIf="filterRow.filter && filterRow.operation">
            <input
              class="form-control  form-control--short"
              *ngIf="
                !(filterRow.filter.options || filtersAdvancedDefaultOptions[filterRow.filter.type]) &&
                filterRow.filter.type !== 'DATE' &&
                filterRow.filter.type !== 'CAMPAIGN'
              "
              [(ngModel)]="filterRow.value"
            />
            <ng-select
              *ngIf="
                !(filterRow.filter.options || filtersAdvancedDefaultOptions[filterRow.filter.type]) && filterRow.filter.type === 'CAMPAIGN'
              "
              [(ngModel)]="filterRow.value"
              [items]="emailList"
              bindLabel="label"
              bindValue="value"
              [clearable]="false"
              class="form-control bulk-options-changer"
            ></ng-select>
            <wsb-atlas-datepicker
              *ngIf="
                !(filterRow.filter.options || filtersAdvancedDefaultOptions[filterRow.filter.type]) && filterRow.filter.type === 'DATE'
              "
              format="date"
              [(ngModel)]="filterRow.value"
            ></wsb-atlas-datepicker>
            <ng-select
              *ngIf="filterRow.filter.options || filtersAdvancedDefaultOptions[filterRow.filter.type]"
              [(ngModel)]="filterRow.value"
              [items]="filterRow.filter.options ? filterRow.filter.options : filtersAdvancedDefaultOptions[filterRow.filter.type]"
              bindLabel="label"
              bindValue="value"
              [clearable]="false"
              class="form-control bulk-options-changer"
            >
              <ng-template ng-label-tmp let-item="item" let-clear="clear">
                <span *ngIf="!item.translate" class="ng-value-label">{{ item.label }}</span>
                <span *ngIf="item.translate" class="ng-value-label">{{ item.label | translate }}</span>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm" let-index="index">
                <span *ngIf="!item.translate">{{ item.label }}</span>
                <span *ngIf="item.translate">{{ item.label | translate }}</span>
              </ng-template>
            </ng-select>
          </ng-container>
        </div>
        <div class="col-3">
          <wsb-atlas-button
            class="float-right"
            *ngIf="last"
            (btnClick)="filterAdvancedAddRow()"
            variant="icon"
            [icon]="faPlus"
            [roundButton]="true"
          ></wsb-atlas-button>
          <wsb-atlas-button
            class="float-right"
            *ngIf="i > 0"
            (btnClick)="filterAdvancedRemoveRow(i)"
            variant="icon"
            [icon]="faMinus"
            [roundButton]="true"
          ></wsb-atlas-button>
        </div>
      </div>

      <!--      <div [class]="'filteroption-type-' + filter.type" *ngFor="let filter of options.filtersAdvanced">-->

      <!--      </div>-->
      <div class="row mt-3">
        <div class="col-12">
          <div>
            <wsb-atlas-button class="mb-2 float-right" [label]="'common_search'" [variant]="'primary'" (click)="filterAdvanced()">
            </wsb-atlas-button>
          </div>
          <div>
            <wsb-atlas-button class="mb-2 me-3 float-right" [label]="'common_reset'" [variant]="'link'" (click)="clearFiltersAdvanced()">
            </wsb-atlas-button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    class="atlas-grid-topfilters row"
    [ngClass]="{
      'atlas-grid-topfilters-has-filters': options.enableSelect || options.bulkOptions,
      'atlas-grid-topfilters-enabled': !loading && numSelected > 0
    }"
    *ngIf="!loading && numSelected > 0"
  >
    <div
      [ngClass]="{ 'col-3': options.bulkOptions, 'col-6': options.enableSelect }"
      class="atlas-grid-topfilters-left"
      [style.visibility]="!loading && numSelected > 0 ? 'visible' : 'hidden'"
    >
      <span
        ><ng-container *ngIf="!(numSelected >= 0)">0 </ng-container
        ><ng-container *ngIf="numSelected >= 0">{{ numSelected }} </ng-container> <ng-container translate>selected</ng-container></span
      >
      <wsb-atlas-button
        *ngIf="!selectAllTotal && numSelected > 0"
        class="mb-2"
        [label]="'common_select_all'"
        [variant]="'link'"
        (click)="selectAll()"
      >
      </wsb-atlas-button>
    </div>
    <div
      class="atlas-grid-topfilters-center centered-placeholder col-6 text-center"
      *ngIf="options.bulkOptions"
      [style.visibility]="!loading && numSelected > 0 ? 'visible' : 'hidden'"
    >
      <ng-container>
        <ng-container *ngIf="options.bulkOptions.length > 1">
          <!--        <select (change)="onBulkOptionSelected($event)" [(ngModel)]="selectedBulkOption" class="form-control">-->
          <!--          <option *ngFor="let option of options.bulkOptions" [ngValue]="option">{{ option.label | translate }}</option>-->
          <!--        </select>-->
          <ng-select
            id="language"
            [(ngModel)]="selectedBulkOption"
            (change)="onBulkOptionSelected($event)"
            [items]="options.bulkOptions"
            placeholder="{{ 'common_choose_option' | translate }}"
            bindLabel="label"
            [clearable]="false"
            class="form-control bulk-options-changer"
          >
            <ng-template ng-label-tmp let-item="item" let-clear="clear">
              <span class="ng-value-label">{{ item.label | translate }}</span>
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-search="searchTerm" let-index="index">
              <span>{{ item.label | translate }}</span>
            </ng-template>
          </ng-select>
        </ng-container>
        <ng-container *ngIf="options.bulkOptions.length === 1">
          <ng-container *ngFor="let item of options.bulkOptions; index as i">
            <wsb-atlas-button class="mb-2 me-2" [variant]="'tertiary'" [label]="item.label" (click)="item.onClick($event)">
              {{ item.label | translate }}
            </wsb-atlas-button>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
    <div
      [ngClass]="{ 'col-3': options.bulkOptions, 'col-6': options.enableSelect }"
      class="atlas-grid-topfilters-right text-end"
      [style.visibility]="!loading && numSelected > 0 ? 'visible' : 'hidden'"
    >
      <wsb-atlas-button *ngIf="numSelected > 0" class="mb-2" [label]="'common_deselect_all'" [variant]="'link'" (click)="deselectAll()">
      </wsb-atlas-button>
    </div>
  </div>
</div>
<!--<div class="col-12" *ngIf="!(options.enableSelect || options.bulkOptions || options.filters)">-->
<!--  <ng-template *ngIf="pagination" [ngTemplateOutlet]="templatePagination" [ngTemplateOutletContext]="{ $implicit: pagination }"></ng-template>-->
<!--</div>-->
<ag-grid-angular
  #agGrid
  *ngIf="columnDefs && options && options.atlasGrid && localeReady"
  class="atlas-grid ag-theme-alpine"
  [columnDefs]="columnDefs"
  [rowData]="rowData"
  [gridOptions]="options"
  [components]="components"
></ag-grid-angular>
<div class="mt-4 atlas-grid-pagination-bottom-container" *ngIf="!options.disablePagination">
  <ng-template
    *ngIf="pagination"
    [ngTemplateOutlet]="templatePagination"
    [ngTemplateOutletContext]="{ $implicit: pagination }"
  ></ng-template>
</div>
